export default __webpack_public_path__ + "static/media/d2.8bf7f229.jpg";